import React from 'react';
import { Link } from 'react-router-dom';
import './SubMenuPanel.css';

export default function SubMenuPanel({ items, activeAiKey }) {
  return (
    <div className="submenu-panel">
      <div className="submenu-sidebar">
        {items.map((item) => (
          <Link
            key={item.key}
            to={item.to}
            className={`submenu-main-item ${activeAiKey === item.key ? 'is-active' : ''}`}
          >
            <span className="submenu-label">{item.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
